<div class="wrapper" [ngClass]="{ left: position === 'left' }">
  <div class="container">
    <p *ngIf="text !== null">{{ text || 'Loading...' }}</p>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
